import { useEffect } from 'react'
import { useLocalStorage } from './useLocalStorage.js'
import { useMediaQuery } from './useMediaQuery.js'

export const THEME_PREFS = ['auto', 'light', 'dark']

// Browser chrome colour per theme (matches --chrome in styles.css).
const CHROME = { light: '#f3f5f7', dark: '#0d1014' }

/**
 * Light/dark theme. 'auto' follows the OS (drivers at night are usually in dark
 * mode). The resolved theme is mirrored onto <html data-theme> — index.html
 * sets it before first paint so there's no light flash — and onto the browser
 * chrome colour.
 */
export function useTheme() {
  const [pref, setPref] = useLocalStorage('zpsp.theme', 'auto', (v) => THEME_PREFS.includes(v))
  const systemDark = useMediaQuery('(prefers-color-scheme: dark)')
  const theme = pref === 'auto' ? (systemDark ? 'dark' : 'light') : pref

  useEffect(() => {
    const root = document.documentElement
    root.dataset.theme = theme
    root.style.colorScheme = theme
    document.querySelector('meta[name="theme-color"]')?.setAttribute('content', CHROME[theme])
  }, [theme])

  return { theme, pref, setPref }
}
